import React from 'react';
import { Box, TextField, MenuItem, FormLabel, Typography, Alert } from '@mui/material';
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector';
import SelectList from '../../../../../Components/Elements/SelectList';
import { BlockSettingsProps } from './types';

export const DateStatisticsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    if (!state.item.defDossier) return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>;
    const getError = (key: string) => (state.errors && state.errors[key]) ? state.errors[key] : undefined;
    return (
        <Box sx={{ mt: 2 }}>
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) => handleChangeSettings('scheme', e.target.value)}
                name={'scheme'}
            />
            <TextField
                select
                required
                size="small"
                fullWidth
                label={kedo.t('Period')}
                name="period"
                value={state.item.settings.period || ''}
                onChange={(e) => handleChangeSettings('period', e.target.value)}
                error={!!getError('period')}
                helperText={getError('period')}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="week">{kedo.t('Week')}</MenuItem>
                <MenuItem value="month">{kedo.t('Month')}</MenuItem>
                <MenuItem value="year">{kedo.t('Year')}</MenuItem>
            </TextField>
            <Box sx={{ mt: 2 }}>
                <FormLabel>
                    {kedo.t('List field')}
                </FormLabel>
                <SelectList
                    currentValue={state.item.settings.count_list_field}
                    onClear={() => handleChangeSettings("count_list_field", null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        page: 0,
                        limit: 200,
                        type: 'list',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => {
                        handleChangeSettings("count_list_field", item.id);
                    }}
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <FormLabel>
                    {kedo.t('Date')} <Typography variant="caption">{kedo.t('Optional')}</Typography>
                </FormLabel>
                <SelectList
                    disableInit={true}
                    currentValue={state.item.settings.date_field}
                    onClear={() => handleChangeSettings('date_field', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        type: 'date',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => {
                        handleChangeSettings('date_field', item.id);
                    }}
                />
            </Box>
        </Box>

    );

};